<template lang="pug">
  .voice-detect
    a#voice-micro.circlebtnBars.speech-recognition-button(:class="{listening:listening}" :disabled="listening" @click="get_voice(set_text)")
      .bar
      .bar
      .bar
      i.fas.fa-microphone
</template>

<script>
import mixins from 'common/mixins.js'
import filters from 'common/filters.js'

export default {
  props: ['maxlength'],
  data() {
    return {
      listening: false,
      text: ''
    }
  },
  mixins: [mixins.voice],
  methods: {
    set_text(text) {
      this.text = this.maxlength ? this.truncate_text(text) : text

      this.$emit('update-text', this.text)
    },
    truncate_text(text) {
      return this.$options.filters.limit_string_length(text, this.maxlength, false)
    },
    clean() {
      this.text = ''
    },
  },
  filters: {
    limit_string_length: filters.limit_string_length
  },
}
</script>
